module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/foreword#_idTextAnchor001"
    }
  }, [_vm._v("Foreword by Mark Labberton")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/intro#_idTextAnchor002"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#_idTextAnchor003"
    }
  }, [_vm._v("1 Biblical Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2#_idTextAnchor016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 God-Centered Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#_idTextAnchor033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Grace-full Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#_idTextAnchor041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Compelling Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#_idTextAnchor049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Imaginative Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#_idTextAnchor055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Contextual Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#_idTextAnchor060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Relevant Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#_idTextAnchor062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Embodied Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#_idTextAnchor065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Self-less Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10#_idTextAnchor068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Getting Feedback About Your Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/conclusion#_idTextAnchor070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/acknowledgments#_idTextAnchor071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendix#_idTextAnchor072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Resources for Inspiration and Education")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#_idTextAnchor073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise#_idTextAnchor131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("A Little Handbook for Preachers")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author#_idTextAnchor132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praxis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IVP Praxis")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP#_idTextAnchor133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP#_idselector",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IVP Textbook Selector")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0